function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
import { forwardRef, omitThemingProps, tqc, useMultiStyleConfig } from '../../system';
import { useFormControl } from '../form-control';
import { cx } from '../../utils';
export var Input = forwardRef((props, ref) => {
  var styles = useMultiStyleConfig('Input', props);
  var ownProps = omitThemingProps(props);
  var input = useFormControl(ownProps);
  var _className = cx('tqc-input', props.className);
  return /*#__PURE__*/React.createElement(tqc.input, _extends({}, input, {
    __css: styles.field,
    ref: ref,
    className: _className
  }));
});
Input.displayName = 'Input';
Input.id = 'Input';